import { PRICE_RULES, priceRulesFiringAt } from '../../lib/btc15PriceRules';
import styles from './Btc15PriceRules.module.css';

/** What each rule would do in the current round, from the live quote. Paper only. */
export function Btc15PriceRulesNow({
  secondsRemaining,
  yesAsk,
  noAsk,
}: {
  secondsRemaining: number | null;
  yesAsk: number | null;
  noAsk: number | null;
}) {
  if (secondsRemaining === null) return null;
  const minute = Math.floor((900 - secondsRemaining) / 60);
  const firing = priceRulesFiringAt(minute, yesAsk, noAsk, new Set());
  // Rules in the same state share one line ("C1, C3, D1 wait for minute 8")
  // rather than repeating it once per rule.
  const groups: Array<{ ids: string[]; waitsFor: number | null; text: string }> = [];
  for (const spec of PRICE_RULES) {
    const fire = firing.find((f) => f.rule === spec.id);
    const waitsFor = minute < spec.firstMinute ? spec.firstMinute : null;
    const text =
      waitsFor !== null
        ? `for minute ${waitsFor}`
        : minute > (spec.lastMinute ?? 14)
          ? 'entry window closed this round'
          : spec.pullback
            ? 'checks once at minute 8–9: favorite at 55–80¢, below its round high'
            : fire
              ? `would buy ${fire.side === 'yes' ? 'UP' : 'DOWN'} at ${Math.round(fire.ask * 100)}¢`
              : `no side at ${Math.round(spec.askLow * 100)}–${Math.round(spec.askHigh * 100)}¢ right now`;
    const group = groups.find((g) => g.text === text);
    if (group) group.ids.push(spec.id);
    else groups.push({ ids: [spec.id], waitsFor, text });
  }
  return (
    <section className={styles.now} aria-labelledby="btc15-price-rules-now-heading">
      <h2 id="btc15-price-rules-now-heading" className={styles.nowHeading}>
        Price rules this round <span className={styles.badge}>Paper</span>
      </h2>
      <ul className={styles.nowList}>
        {groups.map((group) => (
          <li key={group.ids.join()}>
            <span className={styles.ruleId}>{group.ids.join(', ')}</span>{' '}
            {group.waitsFor !== null
              ? `${group.ids.length === 1 ? 'waits' : 'wait'} ${group.text}`
              : group.text}
          </li>
        ))}
      </ul>
    </section>
  );
}
